export default __webpack_public_path__ + "014a0013c7c5d66ed652148a46fa0d66.png";